import React from "react";
import ReceivedRewardsState, { ReceivedRewardsProps } from "./ReceivedRewards.models";
import './ReceivedRewards.scss';
import RewardService from "../../../services/management/RewardService";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";
import { NavLink } from "react-router-dom";

export default class ReceivedRewards extends React.PureComponent<ReceivedRewardsProps, ReceivedRewardsState>{

    rewardService: RewardService;
    constructor(props: any) {
        super(props);
        this.rewardService = new RewardService();
        this.state = { rewards: { rows: [], totalRowCount: 0 } };
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        let self = this;

        self.rewardService.getMyRewards({
            descendingOrder: false,
            orderField: "Point",
            pageSize: 1000,
            pageSkip: 0
        }).then(function (response) {
            self.setState({ rewards: response });
        });
    }

    render(): React.ReactNode {
        let { rewards } = this.state;

        let content;
        if (rewards.rows.length > 0)
            content = (<>
                {rewards.rows.map((reward, key) => {

                    return (<div key={key} className="col-12 notspace margin-top box-shadow">
                        <div className="tk-inline card-boundel">
                            <div className="col-2 notspace">
                                <div className="points success-images">
                                    <label className="mdi mdi-star star"></label>
                                </div>
                            </div>
                            <div className="col-10 notspace" style={{ textAlign: "right", marginRight: "20px" }}>
                                <div className="pd-detail">
                                    <div className="course-title">
                                        <label>{reward.pointDetail}</label>
                                    </div>
                                    <div className="course-subtitle">
                                        <label>{reward.point} امتیاز</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>);
                })}
            </>);
        else content = <NotFoundDataInDate title="جایزه ای دریافت نکرده اید" />;

        let headerView = (<div className="about-headre received-rewards-area">
            <div className="mt-2" >
                <label className="page-title" style={{ color: "black" }}>جوایز دریافت شده</label>
                {/* mdi-light */}
                <NavLink to={"/Rewards?statusPage=3"}>
                    {/* mdi-light  */}
                    <span className="mdi mdi-arrow-left mdi-24px " ></span>
                </NavLink>
            </div>
        </div>);

        return (<>

            <div className="tk-aling-right tk-padding-top received-rewards-area dropdown-list">
                {content}
            </div>
        </>);
    }
}